<template>
  <div class="top-container">
    <div class="table-container">
      <b-table
        :data="tableData"
        :loading="loading"
        :selected.sync="selected"
        :checked-rows.sync="checkedRows"
        checkable
        focusable
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Name">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="assignedUser" label="Assigned To">{{
            props.row.assignedUser
          }}</b-table-column>
          <b-table-column field="status" label="State" width="3rem">
            <span v-if="props.row.status === 'empty'" class="tag">
              Empty
            </span>
            <span
              v-else-if="props.row.status === 'finished'"
              class="tag is-success"
            >
              Finished
            </span>
            <span v-else-if="props.row.status === 'wip'" class="tag is-warning">
              WIP
            </span>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <div class="table-foot">
      <b-button
        class="has-text-right"
        style="margin-left: 1rem"
        @mouseover="hovered = true"
        @mouseleave="hovered = false"
        @click="emptyCheckedRows"
        >{{ this.buttonLabel }}</b-button
      >

      <b-pagination
        :per-page="perPage"
        :total="total"
        :current="currentPage"
        @change="onPageChange"
      >
        <b-pagination-button
          slot="previous"
          slot-scope="props"
          :page="props.page"
        >
          Previous
        </b-pagination-button>

        <b-pagination-button slot="next" slot-scope="props" :page="props.page">
          Next
        </b-pagination-button>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["floorplans", "syncPage", "currentPage", "total", "perPage"],
  data() {
    return {
      hovered: false,
      loading: false
    };
  },
  computed: {
    ...mapState("ui", ["users"]),
    selected: {
      get() {
        return this.$store.state.ui.selectedImageRow;
      },
      set(newVal) {
        this.$store.commit("ui/setSelectedImageRow", newVal);
      }
    },
    checkedRows: {
      get() {
        return this.$store.state.ui.checkedImageRows;
      },
      set(newVal) {
        this.$store.commit("ui/setCheckedImageRows", newVal);
      }
    },
    buttonLabel() {
      if (this.hovered) {
        return "Unselect All";
      } else {
        return this.checkedRows.length + " selected";
      }
    },
    tableData() {
      return this.floorplans;
    }
  },
  methods: {
    emptyCheckedRows() {
      this.$store.commit("ui/setCheckedImageRows", []);
    },
    async onPageChange(page) {
      this.loading = true;
      try {
        await this.syncPage(page);
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    this.emptyCheckedRows();
    this.loading = true;
    try {
      await this.syncPage(this.currentPage);
    } catch (error) {
      console.error("mounted() in AdminFloorplanTable failed at syncPage: ");
      console.error(error);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.top-cotainer {
  overflow: hidden;
}
.table-container {
  overflow-y: scroll;
}
.table-foot {
  display: flex;
  justify-content: space-between;
  margin-right: 1rem;
}
</style>
